import React, {FC, useState, useEffect} from "react"

import authentication from "@irati/auth"
import {getUserAccountCookie, getUserAccountLatestLogosCookie, UserAccountForCookie} from "@irati/utils/cookies/userAccountCookie"
import {getDomain} from "@irati/utils/links"
import Link from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"
import {Hr} from "@irati/ui/src/Layout"
import {H6} from "@irati/ui/src/Typography"

import {AccountImage} from "./styled"

interface Props {}

const SwitchAccount: FC<Props> = () => {
  const [accounts, setAccounts] = useState<UserAccountForCookie[]>(
    getUserAccountCookie().filter(({subdomain: cookieSubdomain}) => authentication.business().subdomain !== cookieSubdomain)
  )

  useEffect(() => {
    if (authentication.isLoggedIn()) {
      if (accounts) {
        getUserAccountLatestLogosCookie(accounts, authentication.business().subdomain).then((updatedUserAccounts) => {
          setAccounts(updatedUserAccounts)
        })
      }
    }
  }, [])

  if (!accounts || accounts.length === 0) {
    return null
  }

  return (
    <>
      <Hr />
      <H6 margin={[1, 2]}>
        <FormattedMessage id="platform.userMenu.accountSwitch.header" />
      </H6>
      {accounts.map(({subdomain, url, image}) => (
        <Link plain href={url} key={subdomain}>
          <AccountImage src={image} />
          {subdomain}
        </Link>
      ))}
      <Link plain href={getDomain("app")} marginBottom={2}>
        <FormattedMessage id="platform.userMenu.accountSwitch.other" />
      </Link>
    </>
  )
}

export default SwitchAccount
